// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1RoAN","subheader":"ReorderModal_subheader__1ytCP","listWrap":"ReorderModal_listWrap__2SM2E"};